import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import {
    faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook,
    faTwitter, faInstagram, faMedium, faBehance, faDribbble,
    faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud
} from '@fortawesome/free-brands-svg-icons';
import '../styles/TemplateSeven.css';

const TemplateSeven = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud,
        website: faLink,
        portfolio: faLink
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud',
        website: 'Website',
        portfolio: 'Portfolio'
    };


    return (
        <div className="template-seven-container" onClick={() => onClick(template?.id)}>
            <div className="template-seven-header">
                {template?.image && <img src={template?.image} alt={template?.personName} className="template-seven-image" />}
                <div className="template-seven-name-title">
                    {template?.name && <h1 className="template-seven-name" style={{ color: 'white' }}>{template?.name}</h1>}
                    {template?.title && <h2 className="template-seven-title">{template?.title}</h2>}
                </div>
            </div>
            <div className="template-seven-body">
                <div className="template-seven-column-left">

                    {template.contact && (
                        <div className="template-seven-section">
                            <h3>Contact</h3>
                            {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                            {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                            {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                        </div>
                    )}


                    {template.skills && Array.isArray(template.skills) && template.skills.length > 0 && (
                        <div className="template-seven-section">
                            <h3>Skills</h3>
                            <ul>
                                {template.skills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template.languages && Array.isArray(template.languages) && (
                        <div className="template-seven-section">
                            <h3>Languages</h3>
                            <ul>
                                {template.languages.map((language, index) => (
                                    <li key={index}>{language}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template.hobbies && Array.isArray(template.hobbies) && (
                        <div className="template-seven-section">
                            <h3>Hobbies</h3>
                            <ul>
                                {template.hobbies.map((hobby, index) => (
                                    <li key={index}>{hobby}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {template?.softwareSkills && Array.isArray(template?.softwareSkills) && template?.softwareSkills.length > 0 && (
                        <div className="template-seven-section">
                            <h3>Software Skills</h3>
                            <div className="software-skills-wrapper">
                                {template?.softwareSkills.map((software, index) => (
                                    <div key={index} className="software-skill-item">
                                        {software}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {template?.links && template?.links.length > 0 && (
                        <div className="template-seven-section software-skills-wrapper">
                            <h3>Links:</h3>
                            <div className="software-skills-wrapper">
                                {template.links.map(([key, value]) => (
                                    <p key={key} className="template-three-link">
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}


                </div>
                <div className="template-seven-column-right">

                    {template.aboutMe && template.aboutMe.length > 0 && (
                        <div className="template-seven-section">
                            <h3>About Me</h3>
                            <p>{template.aboutMe}</p>
                        </div>
                    )}

                    {template.workExperience && Array.isArray(template.workExperience) && template.workExperience.length > 0 && (
                        <div className="template-seven-section">
                            <h3>Work Experience</h3>
                            {template.workExperience.map((experience, index) => (
                                <div key={index} className="template-seven-experience-item">
                                    <p className="template-seven-role">{experience.role}</p>
                                    <p className="template-seven-company-location">{experience.company}, {experience.location}</p>
                                    <p className="template-seven-date">
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                    </p>
                                    <p>{experience.description}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {template.education && Array.isArray(template.education) && template.education.length > 0 && (
                        <div className="template-seven-section">
                            <h3>Education</h3>
                            {template.education.map((edu, index) => (
                                <div key={index} className="template-seven-education-item">
                                    <p className="template-seven-degree">{edu.degree}</p>
                                    <p className="template-seven-institution">{edu.institution}</p>
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    <p className="view-template-eight-institution">{edu.description}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {template.certificates && Array.isArray(template.certificates) && template.certificates.length > 0 && (
                        <div className="template-seven-section">
                            <h3>Certificates</h3>
                            {template.certificates.map((certificate, index) => (
                                <div key={index} className="template-seven-education-item">
                                    <p className="template-seven-degree">Title: {certificate.title}</p>
                                    <p className="template-seven-institution">Institution: {certificate.institution}</p>
                                    <p className="template-seven-date">
                                        Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TemplateSeven;
